import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useQualifications = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["qualifications", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.QUALIFICATIONS.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useQualificationsFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["qualificationsFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.QUALIFICATIONS.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useQualificationOptions = (params = {}) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["qualificationOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.QUALIFICATIONS.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateQualification = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.QUALIFICATIONS.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.QUALIFICATIONS.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateQualification = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.QUALIFICATIONS.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.QUALIFICATIONS.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteQualification = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.QUALIFICATIONS.base}/${id}`,
                token,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}